import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef } from 'react';
import 'prop-types';
import styled, { css } from '@xstyled/styled-components';
import { system } from '@trybeapp/ui.system';
import { getMax } from '@trybeapp/ui.utilities';

var _excluded = ["children", "dataTestId"];
var _templateObject, _templateObject2;
var shapeStyles = function shapeStyles(width, height, shape) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n"])), getMax(width, height), getMax(width, height), shape === 'circle' && '50%');
};
var StyledShape = /*#__PURE__*/styled.div(function (_ref) {
  var height = _ref.height,
    shape = _ref.shape,
    width = _ref.width;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n    ", "\n\n  img {\n      object-fit: cover;\n      overflow: hidden;\n      width: 100%;\n      height: 100%;\n    }\n  "])), system, shape && shapeStyles(width, height, shape));
});
var Shape = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    dataTestId = _ref2.dataTestId,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledShape, _extends({
    "data-testid": dataTestId,
    ref: ref
  }, rest), children);
});
Shape.displayName = 'Shape';

export { Shape };
